import type { MisoNotificationsForSiteParams, MisoNotificationsForSiteResponse } from '@/types/eos/MisoNotifications'
import axios from 'axios'

/**
 * Gets a site's MISO notifications for a single MISO (EST) day.
 *
 * The response's 24 hours are hour-beginning UTC and span the requested EST day.
 * Alerts for every MISO region are returned -- filtering against the site's region
 * is the client's job (see helpers/eos/miso-notifications).
 *
 * @param {MisoNotificationsForSiteParams} params the site ID and the EST day ('YYYY-MM-DD').
 * @returns {Promise<MisoNotificationsForSiteResponse>} the day's notifications and hourly activity.
 */
export async function getMisoNotificationsForSite(params: MisoNotificationsForSiteParams) {
  const res = await axios.get<MisoNotificationsForSiteResponse>(import.meta.env.VITE_APP_MISO_NOTIFICATIONS_ENDPOINT, {
    params,
  })
  return res.data
}
